import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RouteNavigationService } from '@core/services/system/route-navigation/route-navigation.service';

@Injectable({ providedIn: 'root' })
export class InitResolver  {
  constructor(private routeNavigationService: RouteNavigationService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    return this.routeNavigationService.isInitializationFinished();
  }
}
